import React from 'react';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import {
  useCalendarManager,
  useCalendarViewData,
} from '../../../../services/queries/calendar';
import Header from './Header';
import CalendarModePageGuard from '../../controllers/CalendarModePageGuard';
import { useSearchParamsSelector } from '../../../../shared/packages/searchParamsManager';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import Calendar from './Calendar';
import { useFrozenValueUntil } from '../../../../shared/hooks/frozenValueUntil';
import AddCalendarIntervalsModal from '../../controllers/AddCalendarIntervalsModal';
import { useUserAcceptanceRole } from '../../../../shared/hooks/userAcceptanceRole';
import { HeaderSizeCalculatorProvider } from './services/headerSizeCalculator';
import styles from './index.module.scss';

const CalendarView = () => {
  const role = useUserAcceptanceRole();

  return (
    <CalendarModePageGuard>
      <Content>
        <Header />
      </Content>

      {role.isDirector && <AddCalendarIntervalsModal />}
    </CalendarModePageGuard>
  );
};

export default CalendarView;

function Content({ children }) {
  const { data, isFetching, refetch } = useCalendarViewData();

  const page = useSearchParamsSelector((state) => {
    return Number(state[searchParamKeys.calendarPage]);
  });

  const mode = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.calendarMode]
  );

  const calendarManager = useCalendarManager();

  const frozenProps = useFrozenValueUntil(
    { page, mode, data, calendarManager },
    [page, mode, data, calendarManager],
    !isFetching
  );

  return (
    <FetchDataWrapper
      className="grow1"
      data={frozenProps.data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg="Не удалось получить данные выбранной приемки"
      ignoreEmpty
    >
      <div className={styles.root}>
        <HeaderSizeCalculatorProvider>
          {children}
          <Calendar
            page={frozenProps.page}
            mode={frozenProps.mode}
            data={frozenProps.data}
            calendarManager={frozenProps.calendarManager}
          />
        </HeaderSizeCalculatorProvider>
      </div>
    </FetchDataWrapper>
  );
}
